// Přejmenuje výchozí řazení (první položka, Shoptet ji nazývá „Doporučujeme“) podle datalayeru.
// Řazení vykresluje doplněk dkLab až po DOM ready, proto se volá i po jeho událostech níže.
window.renameRecommendedSorting = function (sorting) {
    if (!sorting || !sorting.priorityText) {
        return;
    }

    const $button = $(".listSorting__controls li:first-child .listSorting__control");

    if ($button.length === 0) {
        return;
    }

    $button.text(sorting.priorityText);

    if ($button.hasClass("listSorting__control--current")) {
        $button.attr("aria-label", sorting.priorityText + sorting.currentSuffix);
    }
};

// Na mobilu má tlačítko filtrů místo „Zobrazit / Skrýt filtry“ jeden text z datalayeru,
// stav ukazuje otočená šipka. Bez textu v datalayeru zůstává text doplňku.
window.renameMobileFiltersButton = function (filters) {
    if (!filters || !filters.mobileButtonText) {
        return;
    }

    $("#dkLabTopFilters .dkLab-filters-pack-button .span__pack-button").text(filters.mobileButtonText);
};

["dkLabFiltersLoaded", "dkLabFiltersChanged", "ShoptetDOMPageContentLoaded"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
        if ($(".type-category").length) {
            renameRecommendedSorting(getTerezaDataLayer().sorting);
            renameMobileFiltersButton(getTerezaDataLayer().filters);
        }
    });
});

// Na mobilu jsou filtry a řazení v jednom řádku — otevření jedné nabídky zavře druhou.
$(document).on("click", "#dkLabTopFilters .dkLab-filters-pack-button .open", function () {
    if (window.matchMedia("(max-width: 767px)").matches && $("#dkLabTopFilters #category-header").hasClass("active")) {
        $("#dkLabTopFilters #category-header > .span--sort").trigger("click");
    }
});

$(document).on("click", "#dkLabTopFilters #category-header > .span--sort", function () {
    // Doplněk přepne .active na hlavičce dřív, než klik probublá sem — active = řazení se právě otevřelo.
    if (window.matchMedia("(max-width: 767px)").matches && $("#dkLabTopFilters #category-header").hasClass("active")) {
        $("#dkLabTopFilters .dkLab-filters-pack-button .close.visible").trigger("click");
    }
});

// Prohodí velikost obrázku v URL (related/big/orig/detail)
// Nové podepsané URL (od 24. 6. 2026) mají query parametry x/y/q/sg —
// po úpravě cesty by řídily výstup, proto se z query nechává jen ts=
window.myImageSize = function (url, size) {
    if (!url) {
        return url;
    }

    const parts = url.split("?");
    const base = parts[0].replace(/\/(related|big|orig|detail|category)\//, "/" + size + "/");
    const query = parts[1] || "";

    // Stará URL bez podpisu — query (cache hash) se nechává beze změny
    if (query.indexOf("sg=") === -1) {
        return query ? base + "?" + query : base;
    }

    const ts = query.split("&").filter(function (param) { return param.indexOf("ts=") === 0; })[0];
    return ts ? base + "?" + ts : base;
};

// Vybere datalayer podle jazykové mutace. EN mutace běží na stejném CZ balíku,
// takže když en-datalayer.js chybí nebo se nenačte, padáme zpět na český.
// Klíč sorting přibyl později — prázdný default drží skript naživu i tehdy,
// když prohlížeč servíruje starší nacachovaný datalayer.js.
window.getTerezaDataLayer = function () {
    const layer = getShoptetDataLayer().language === "en" && typeof enTerezaDataLayer !== "undefined" ? enTerezaDataLayer : czTerezaDataLayer;

    return Object.assign({ sorting: {} }, layer);
};

jQuery(document).ready(function () {
    $.colorbox.settings.transition = "none";
    var lastScrollTop = 0; // Uchování poslední pozice scrollu

    $(window).on("scroll", function () {
        var currentScrollTop = $(this).scrollTop();

        // Pokud uživatel úplně nahoře, odstraníme všechny třídy
        if (currentScrollTop === 0) {
            $("html").removeClass("scrolled scrolled-up scrolled-down");
        } else {
            $("html").addClass("scrolled"); // Přidání třídy, pokud se stránka scrolluje

            // Kontrola směru scrollování
            if (currentScrollTop > lastScrollTop) {
                $("html").removeClass("scrolled-up").addClass("scrolled-down");
            } else {
                $("html").removeClass("scrolled-down").addClass("scrolled-up");
            }
        }

        lastScrollTop = currentScrollTop; // Aktualizace poslední pozice scrollu
    });

    let terezaDataLayer = getTerezaDataLayer();
    if ($(".jk-signature").length > 0) {
        $(".jk-signature").parent("span").parent(".banner-wrapper").parent(".banner").parent().hide();
        $(".jk-signature").prependTo("#signature");
        $("#signature .title").html("Shoptet");
    } else {
        $("<span class='jk-signature'>Vytvořil <a href='https://jankolonicny.cz/' target='_blank'><img src='/user/documents/upload/kodovani/jk.svg' alt='' class='jankolonicny-logo' width='30' loading='lazy'></a> & </span>").prependTo("#signature");
        $("#signature .title").html("Shoptet");
    }
    $("#signature > a.image > img").attr("src", "/user/documents/upload/kodovani/shoptetLogo.svg");
    if ($(".siteCookies__form").length > 0) {
        $(".siteCookies__link").appendTo(".siteCookies__buttonWrap");
        $(".js-cookiesConsentSubmit").html(terezaDataLayer.cookies.submitBtnText);
        $(".js-cookies-settings").html(terezaDataLayer.cookies.ownSettingsButtonText);
    }
    // Posune menu-level-2 na levou hranu headeru (ne na viewport 0),
    // aby bylo zarovnané i nad 1920px (header je centrovaný s max-width).
    function positionMenuDropdown($item) {
        if (!$item.length) return;
        var $menu = $item.find("> .menu-level-2");
        if (!$menu.length) return;
        var headerLeft = $("#header").offset().left;
        var itemLeft = $item.offset().left;
        $menu.css("left", "-" + (itemLeft - headerLeft) + "px");
    }

    // Položka ze secondMenus bez odkazů ("links" chybí nebo je prázdné) nemá megamenu
    // a zůstává obyčejným odkazem. Volitelný klíč "link" jí přepíše adresu, takže
    // ji klientka přepne čistě v datalayeru, bez sahání na menu v administraci.
    let secondMenusWithMegaMenu = [];
    for (secondMenu of terezaDataLayer.megaMenu.secondMenus) {
        if (secondMenu.link) {
            $("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id + " > a").attr("href", secondMenu.link);
        }
        if (secondMenu.links && secondMenu.links.length) {
            secondMenusWithMegaMenu.push(secondMenu);
        }
    }

    if ($(window).width() > 991) {
        $(".languagesMenu__list__name").each(function () {
            if ($(this).text().trim() === "Čeština") {
                $(this).text("CZ");
            }
            if ($(this).text().trim() === "English") {
                $(this).text("EN");
            }
        });
        $(".languagesMenu__header--actual").each(function () {
            var $header = $(this);
            var $caret = $header.find("span.caret").detach();
            var text = $header.text().trim();
            if (text.includes("Čeština")) {
                $header.text("CZ");
            } else if (text.includes("English")) {
                $header.text("EN");
            }
            $header.append($caret);
        });
        $("#navigation .menu-item-903").addClass("special").removeClass("ext");
        positionMenuDropdown($("#navigation .menu-item-903"));
        // Klíč megaMenuAdditionalInfo je nepovinný — když chybí nebo je prázdný,
        // blok se nevykreslí (dřív se vypsalo "undefined")
        let additionalInfo = terezaDataLayer.megaMenuAdditionalInfo || "";
        $("<div class='mymenu-wrapper'><div class='mymenu'><div class='menu-item-banner'><img src='" + terezaDataLayer.megaMenu.eshopImage + "'></div></div>" + (additionalInfo ? "<div class='megamenu-additional-info'>" + additionalInfo + "</div>" : "") + "</div>").appendTo("#navigation .menu-item-903 .menu-level-2");
        $("#navigation .menu-item-903 .menu-level-2 > *:not(.mymenu-wrapper").appendTo("#navigation .menu-item-903 .menu-level-2 .mymenu");
        $("#navigation .menu-item-903 .menu-level-2 li").each(function () {
            let parentLink = $(this).children("a").attr("href");
            $("#footer #categories a[href='" + parentLink + "']")
                .next("ul")
                .appendTo($(this));
        });
        for (secondMenu of secondMenusWithMegaMenu) {
            $("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id).addClass("special");
            $("<ul class='menu-level-2'><div class='mymenu-wrapper'><div class='mymenu'><li><ul></ul></li><div class='menu-item-banner'><img src='" + secondMenu.image + "'></div></div></ul>").appendTo("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id);
            for (link of secondMenu.links) {
                $("<li><a href='" + link.link + "'>" + link.title + "</a></li>").appendTo("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id + " .menu-level-2 .mymenu ul");
            }
        }
        // Dopočítá pozice všech .special dropdownů až po stabilizaci layoutu
        // (items se po addClass("special") posouvají, individuální setTimeout
        // uvnitř smyčky někdy chytá mezi-stav).
        setTimeout(function () {
            requestAnimationFrame(function () {
                $("#navigation .menu-level-1 > li.special").each(function () {
                    positionMenuDropdown($(this));
                });
            });
        }, 500);
        $("<li><a href='" + terezaDataLayer.megaMenu.additionalLink.link + "'>" + terezaDataLayer.megaMenu.additionalLink.name + "</a></li>").appendTo(".mymenu .menu-item-" + terezaDataLayer.megaMenu.additionalLink.parent + " > ul");
        $("<a class='fake-search'></a>").prependTo(".navigation-buttons");
        $(".fake-search").click(function () {
            // Animovaný přesun na vrch stránky
            $("html, body").animate({ scrollTop: 0 }, 300, function () {
                $("body").addClass("user-action-visible search-window-visible");
            });
        });
        // Měna a jazyky se mají chovat jako .special položky v menu — hover jen podtrhne,
        // otevírá až klik.
        //
        // Starý markup (.dropdown + #topNavigationDropdown): klik řeší Bootstrap
        // data-toggle="dropdown", takže stačí, že tu není hover handler.
        //
        // Nový markup (.languagesMenu__box.toggle-window[data-hover="true"]): klik řeší
        // Shoptet delegovaně na documentu, ale hover si věší přímo na element při initu.
        // Atribut data-hover po initu už nic nezmění, proto mouseenter i mouseleave
        // chytneme v capture fázi o úroveň výš a nepustíme je dál. Capture umí jen
        // nativní addEventListener, jQuery ne. Mouseleave blokujeme proto, že Shoptet
        // na něm po 300 ms zavírá VŠECHNA content okna — včetně otevřené search lišty.
        const languagesMenuContent = document.querySelector(".languagesMenu__content");
        if (languagesMenuContent) {
            ["mouseenter", "mouseleave"].forEach(function (eventType) {
                languagesMenuContent.addEventListener(
                    eventType,
                    function (e) {
                        if (e.target.closest && e.target.closest(".toggle-window")) {
                            e.stopPropagation();
                        }
                    },
                    true
                );
            });
        }

        $(".scrolled #header .navigation-buttons > a[data-target='search']").click(function (event) { });

        var menuResizeTimer;
        $(window).on("resize", function () {
            clearTimeout(menuResizeTimer);
            menuResizeTimer = setTimeout(function () {
                if ($(window).width() <= 991) return;
                requestAnimationFrame(function () {
                    $("#navigation .menu-level-1 > li.special").each(function () {
                        positionMenuDropdown($(this));
                    });
                });
            }, 150);
        });
    } else {
        $("#navigation .menu-item-" + terezaDataLayer.megaMenu.id + " .menu-level-2 li").each(function () {
            let parentLink = $(this).children("a").attr("href");
            $("#footer #categories a[href='" + parentLink + "']")
                .next("ul")
                .attr("class", "menu-level-3")
                .appendTo($(this));
        });
        for (secondMenu of secondMenusWithMegaMenu) {
            $("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id).addClass("ext forbidden");
            $('<span class="submenu-arrow"></span>').appendTo("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id + " > a");
            $("<ul class='menu-level-2'></ul>").appendTo("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id);
            for (link of secondMenu.links) {
                $("<li><a href='" + link.link + "'>" + link.title + "</a></li>").appendTo("#navigation .menu-level-1 > .menu-item-external-" + secondMenu.id + " .menu-level-2");
            }
        }
        $("<span class='menu-arrow'></span>").appendTo("#navigation ul.menu-level-2 > li:has(.menu-level-3) > a");
        $(".menu-arrow").click(function (event) {
            event.preventDefault();
            if ($(this).hasClass("opened")) {
                $(this).parent().next(".menu-level-3").slideUp();
            } else {
                $(this).parent().next(".menu-level-3").slideDown();
            }
            $(this).toggleClass("opened");
        });
        for (item of terezaDataLayer.mobileMenu.forbiddenCategories) {
            $("#navigation .navigation-in .menu-item-" + item).addClass("forbidden");
        }
        if (terezaDataLayer.megaMenuAdditionalInfo) {
            $("<div class='nav-additional'>" + terezaDataLayer.megaMenuAdditionalInfo + "</div>").appendTo(".navigation-in");
        }
        $("<li class='menu-item-login'><a href='/login'><b>" + terezaDataLayer.mobileMenu.loginText + "</b></a></li>").appendTo("#navigation .menu-level-1");

        if ($(".languagesMenu__box").length > 1) {
            $(".languagesMenu__list__name").each(function () {
                if ($(this).text().trim() === "Čeština") {
                    $(this).text("CZ");
                }
                if ($(this).text().trim() === "English") {
                    $(this).text("EN");
                }
            });
            $(".languagesMenu__header--actual").each(function () {
                if ($(this).text().trim().includes("Čeština")) {
                    $(this).html($(this).html().replace("Čeština", "CZ"));
                }
                if ($(this).text().trim().includes("English")) {
                    $(this).html($(this).html().replace("English", "EN"));
                }
            });
            $(".languagesMenu__box").each(function () {
                $("<li class='menu-item-" + $(this).attr("data-target") + " ext forbidden'><a><b>" + $(this).find(".languagesMenu__header--name").text().trim() + " (" + $(this).find(".languagesMenu__header--actual").text().trim() + ")</b><span class='submenu-arrow'></span></a><ul class='menu-level-2'></ul></li>").appendTo(
                    "#navigation .menu-level-1"
                );
                $(this)
                    .find(".languagesMenu__list li")
                    .appendTo(".menu-item-" + $(this).attr("data-target") + " .menu-level-2");
            });
            // Shoptet renderuje boxy v pořadí měna → jazyk, v mobilním menu chceme jazyk první
            $("#navigation .menu-level-1 > .menu-item-language").insertBefore("#navigation .menu-level-1 > .menu-item-currency");
        } else {
            $("<li class='menu-item-currency ext forbidden'><a><b>Měna (" + $("#topNavigationDropdown").text().trim() + ")</b><span class='submenu-arrow'></span></a><ul class='menu-level-2'></ul></li>").appendTo("#navigation .menu-level-1");
            $(".navigation-buttons .dropdown-menu li").appendTo(".menu-item-currency .menu-level-2");
        }
    }
    // Odstranění třídy ext ze všech .special elementů (aby nefungoval hover efekt)
    $("#navigation li.special").removeClass("ext");

    // Click event pro zobrazení/skrytí menu
    $(document).on("click", "#navigation li.special", function (e) {
        var $target = $(e.target);
        // Pokud klikneme na odkaz v menu-level-2, necháme ho projít
        if ($target.closest(".menu-level-2 a").length > 0) {
            return;
        }

        // Pokud klikneme na odkaz v .special (ale ne v menu-level-2), také necháme projít
        if ($target.is("a") && !$target.closest(".menu-level-2").length) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        var $menu = $this.find(".menu-level-2");
        // Přepočet pozice při každém otevření — layout se mezi resize a klikem
        // může posunout (breakpointy, scrollbar, lazy content).
        positionMenuDropdown($this);
        var $otherOpenMenus = $("#navigation li.special")
            .not($this)
            .filter(function () {
                return $(this).find(".menu-level-2").css("max-height") !== "0px" && $(this).find(".menu-level-2").css("max-height") !== "none";
            });
        var animationDuration = 500; // ms
        var currentHeight = $menu[0].scrollHeight;
        var isCurrentlyOpen = $menu.css("max-height") !== "0px" && $menu.css("max-height") !== "none";

        // Pokud klikáme na otevřené menu - zavřeme ho
        if (isCurrentlyOpen) {
            $menu.css("max-height", "0");
            $this.removeClass("exp");
            setTimeout(function () {
                if ($("#navigation li.special.exp").length === 0) {
                    $("body").removeClass("submenu-visible");
                }
            }, animationDuration);
        }
        // Pokud klikáme na zavřené menu a nějaké je otevřené
        else if ($otherOpenMenus.length > 0) {
            // Nejdřív zavřeme ostatní otevřená menu
            $otherOpenMenus.each(function () {
                $(this).find(".menu-level-2").css("max-height", "0");
                $(this).removeClass("exp");
            });

            // Po dokončení animace zavření otevřeme nové menu
            setTimeout(function () {
                $menu.css("max-height", currentHeight + "px");
                $this.addClass("exp");
                $("body").addClass("submenu-visible");
            }, animationDuration - 200);
        }
        // Pokud klikáme a žádné není otevřené
        else {
            $menu.css("max-height", currentHeight + "px");
            $this.addClass("exp");
            $("body").addClass("submenu-visible");
        }
    });

    // Zavření menu při kliknutí mimo menu
    $(document).on("click", function (e) {
        var $target = $(e.target);
        // Ignorujeme zavření, pokud klikneme na .special.exp nebo uvnitř .menu-level-2
        var isClickOnSpecialExp = $target.closest("#navigation li.special.exp").length > 0;
        var isClickInsideMenuLevel2 = $target.closest("#navigation .menu-level-2").length > 0;

        if (!isClickOnSpecialExp && !isClickInsideMenuLevel2) {
            var $openMenus = $("#navigation li.special").filter(function () {
                return $(this).find(".menu-level-2").css("max-height") !== "0px" && $(this).find(".menu-level-2").css("max-height") !== "none";
            });

            if ($openMenus.length > 0) {
                var animationDuration = 500; // ms
                $openMenus.each(function () {
                    $(this).find(".menu-level-2").css("max-height", "0");
                    $(this).removeClass("exp");
                });

                setTimeout(function () {
                    $("body").removeClass("submenu-visible");
                }, animationDuration);
            }
        }
    });
    if ($(".in-index").length > 0) {
        $(".products-block").each(function (index) {
            $(this)
                .addClass("swiper-wrapper")
                .wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
            $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
            $($(this).find(".product")).addClass("swiper-slide");
            const productSwiper = new Swiper(".myproducts-swiper-" + index, {
                loop: false,
                pagination: {
                    el: ".myswiper-navi-" + index + " .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".myswiper-navi-" + index + " .myswiper-next",
                    prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
                },
                breakpoints: {
                    1600: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    992: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: true,
                        },
                    },
                    500: {
                        spaceBetween: 30,
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: false,
                        },
                    },
                    360: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        navigation: {
                            enabled: false,
                        },
                    },
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
            });
        });
        for (slider of terezaDataLayer.hpSliders) {
            $('<div class="btn-holder hp-products"><a href="' + slider.link + '" class="mybtn mybtn-primary homepage-product-btn">' + slider.text + "</a></div>").appendTo("#homepageProducts" + slider.id);
        }
        $(".welcome").appendTo("#content");
        $(".next-to-carousel-banners").insertBefore(".welcome");
        const reviewsSwiper = new Swiper(".reviews .swiper", {
            autoHeight: true,
            loop: false,
            pagination: {
                el: ".whole-wrap:has(.reviews-inner) .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".whole-wrap:has(.reviews-inner) .swiper-button-next",
                prevEl: ".whole-wrap:has(.reviews-inner) .swiper-button-prev",
            },
            autoplay: {
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                500: {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                320: {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
            },
        });
    }
    $(".product").each(function () {
        if ($(this).find('.flag[class*="flag-material"]').length > 0 || $(this).find(".widget-parameter-wrapper").length > 0) {
            if ($(this).find(".material").length == 0) {
                $("<div class='material'></div>").appendTo($(this).find(".p-in-in"));
                if ($(this).find(".flag-material-14kt-zlato").length) {
                    $(this).find(".flag-material-14kt-zlato").clone().appendTo($(this).find(".material"));
                } else {
                    $(this).find('.flag[class*="flag-material"]').appendTo($(this).find(".material"));
                }
                $(this).find(".widget-parameter-list").appendTo($(this).find(".material"));
            }
        }
    });
    if ($("#footer").length > 0) {
        if ($(".custom-footer__instagram .instagram-widget > a").length >= terezaDataLayer.instagram.numberOfPosts) {
            $("<div class='myig'><h2>" + terezaDataLayer.instagram.title + "</h2><h3>" + terezaDataLayer.instagram.subtitle + "</h3><div class='myig-inner'></div></div>").insertBefore("#footer");
            $(".custom-footer__instagram .instagram-widget > a:nth-child(-n+6)").appendTo(".myig-inner");
        }
        if ($(window).width() < 768) {
            $(".custom-footer h4").each(function () {
                // Najde rodičovský div a vybere vše kromě h4 pro skrytí
                var siblings = $(this).siblings();
                siblings.hide(); // Skryje sourozence při načtení stránky

                $(this).click(function () {
                    if ($(this).hasClass("collapsed")) {
                        $(this).removeClass("collapsed");
                        siblings.slideUp(); // Plynulé skrytí obsahu
                    } else {
                        $(this).addClass("collapsed");
                        siblings.slideDown(); // Plynulé zobrazení obsahu
                    }
                });
            });
        }
    }
    if ($(".type-category").length) {
        if ($(".listSorting__controls button[data-sort='-date']").length == 0) {
            const $firstButton = $(".listSorting__controls button").first();
            const dataUrl = $firstButton.attr("data-url").replace(/(\?order=).*/, "$1-date");

            const newButton = $("<button>", {
                type: "button",
                id: "listSortingControl--date",
                class: "listSorting__control",
                "data-sort": "-date",
                "data-url": dataUrl,
                text: terezaDataLayer.sorting.newestText,
            });

            $("<li>").append(newButton).appendTo(".listSorting__controls");
        }

        if (window.location.search.indexOf("order=-date") !== -1) {
            $(".listSorting__controls .listSorting__control")
                .removeClass("listSorting__control--current")
                .removeAttr("aria-disabled")
                .removeAttr("aria-label");
            $('.listSorting__controls button[data-sort="-date"]')
                .addClass("listSorting__control--current")
                .attr("aria-disabled", "true")
                .attr("aria-label", terezaDataLayer.sorting.newestText + terezaDataLayer.sorting.currentSuffix);
        }

        renameRecommendedSorting(terezaDataLayer.sorting);

        // Shoptet AJAX sort callback hází TypeError, protože server v response nezná -date
        // (žádný button nemá --current → D8 assertion fail). Pro -date děláme plnou navigaci.
        document.addEventListener(
            "click",
            function (e) {
                const btn = e.target.closest('button[data-sort="-date"]');
                if (btn && btn.dataset.url) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    window.location.href = btn.dataset.url;
                }
            },
            true
        );
    }
    // Pruh s nadpisem jen na podstránkách; kategorie mají nadpis nativně v .category-top
    if ($(".type-page").length > 0) {
        $("<div class='page-introduction'></div>").insertBefore("#content-wrapper");
        $("h1").appendTo(".page-introduction");
    }
    // Pozadí za nadpisem stránky z administrace (pageBackgrounds v datalayeru).
    // Klíč = cesta, hodnota = URL obrázku; "default" platí pro vše bez vlastního klíče; jinak pozadí z CSS.
    const introBackgrounds = $(".type-page").length > 0 ? terezaDataLayer.pageBackgrounds : null;

    if (introBackgrounds && typeof introBackgrounds === "object") {
        const normalizeIntroPath = function (path) {
            let cleanPath = String(path).replace(/^https?:\/\/[^/]+/, "").split(/[?#]/)[0];
            cleanPath = cleanPath.replace(/\/strana-\d+\/?$/, "/");
            cleanPath = ("/" + cleanPath + "/").replace(/\/{2,}/g, "/");
            return cleanPath.toLowerCase();
        };
        const currentPath = normalizeIntroPath(window.location.pathname);
        let backgroundUrl = "";

        Object.keys(introBackgrounds).forEach(function (key) {
            if (key !== "default" && normalizeIntroPath(key) === currentPath) {
                backgroundUrl = introBackgrounds[key];
            }
        });

        if (!backgroundUrl && introBackgrounds["default"]) {
            backgroundUrl = introBackgrounds["default"];
        }

        if (typeof backgroundUrl === "string" && backgroundUrl.trim() !== "") {
            $(".page-introduction").css("background-image", 'url("' + backgroundUrl.trim().replace(/"/g, "%22") + '")');
        }
    }
    if ($(".type-posts-listing").length > 0) {
        $("<div class='page-introduction'></div>").insertBefore("#content-wrapper");
        $("h1").appendTo(".page-introduction");
        if ($(".content-inner").children().first().attr("id") !== "newsWrapper") {
            // Získej všechny elementy před #newsWrapper
            var elementsBeforeNewsWrapper = $("#newsWrapper").prevAll().toArray().reverse();

            // Vytvoř nový div.category-top a div.category-perex a přidej ho na začátek .content-inner
            var categoryTop = $('<div class="category-top"><div class="category-perex"></div></div>');
            $(".content-inner").prepend(categoryTop);

            // Přidej všechny elementy před #newsWrapper do divu.category-perex, vyjma h1
            elementsBeforeNewsWrapper.forEach(function (element) {
                if ($(element).prop("tagName").toLowerCase() !== "h1") {
                    $(".category-perex").append(element);
                }
            });
        }

        if ($(".myblog-categories").length == 0) {
            $("<div class='myblog-categories'></div>").insertBefore("#newsWrapper");
            for (item of terezaDataLayer.blogCategories) {
                $("<a href='" + item.link + "' class='myblog-category'>" + item.text + "</a>").appendTo(".myblog-categories");
            }
        }
    }
    if ($(".type-post").length > 0) {
        $("<div class='page-introduction'></div>").insertBefore("#content-wrapper");
        if ($(".main-blog-photo").length > 0) {
            $(".main-blog-photo").appendTo(".page-introduction");
        } else {
            $("h1").appendTo(".page-introduction");
            $(".news-item-detail > time").appendTo(".page-introduction");
        }
        $("<div class='detail-loader'></div>").appendTo("#content-wrapper");
        $.get(
            "/",
            function (data) {
                var response = $($.parseHTML(data));
                $(response).find(".my-usps").appendTo(".detail-loader");
            },
            null,
            "html"
        ).done(function () { });
    }
    if ($(".type-detail").length > 0) {
        $(".p-to-cart-block .p-final-price-wrapper").insertBefore("#product-detail-form");
        var totalVariants = $(".variant-list").length - 1;
        $(".variant-list").each(function (index) {
            if ($(this).find("select").length > 0) {
                $("<div class='my-variants' data='" + $(this).find("select").attr("id") + "' data-name='" + $(this).find("select").attr("data-parameter-name") + "'></div>").appendTo($(this).find("td"));
                $(this)
                    .find("option:not([data-index='0'])")
                    .each(function () {
                        $("<div class='my-variant' value='" + $(this).attr("value") + "'>" + $(this).text() + "</div>").appendTo($(this).closest("td").find(".my-variants"));
                    });
                $(".my-variant").click(function () {
                    var selectElement = $("#" + $(this).parent(".my-variants").attr("data"));
                    var myvalue = $(this).attr("value");
                    selectElement.val(myvalue);
                    var event = new Event("change", { bubbles: true });
                    selectElement[0].dispatchEvent(event);

                    $(this).parent(".my-variants").find(".active").removeClass("active");
                    $(this).addClass("active");
                });
                $(this).find("select").hide();
                $(this).find(".my-variants > div:first-child").click();
            } else {
                $(this).find(".advanced-parameter").first().click();
            }
            if (index == totalVariants) {
                $(this).addClass("last");
            }
        });

        if (typeof $.colorbox !== "undefined" && $.colorbox.settings) {
            $.colorbox.settings.transition = "none";
        }

        if ($(".p-image-wrapper").length > 0 && typeof Swiper !== "undefined") {
            const $sgWrapper = $(".p-image-wrapper");
            const $sgImage = $sgWrapper.find(".p-image");
            const $sgThumbsInner = $sgWrapper.find(".p-thumbnails-inner > div");
            const $sgThumbs = $sgThumbsInner.find(".p-thumbnail");

            if ($sgThumbs.length >= 1) {
                const sgEscAttr = function (v) {
                    return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
                };

                const sgSlides = [];
                $sgThumbs.each(function () {
                    const $img = $(this).find("img");
                    sgSlides.push({
                        url: $(this).attr("href"),
                        alt: $img.attr("alt") || "",
                        thumbSrc: $img.attr("data-src") || $img.attr("src"),
                    });
                });

                const sgMainHTML = sgSlides.map(function (s, i) {
                    const url = sgEscAttr(s.url);
                    const alt = sgEscAttr(s.alt);
                    const loadAttrs = i === 0 ? "fetchpriority='high'" : "loading='lazy'";
                    return (
                        "<div class='swiper-slide' data-href='" + url + "'>" +
                        "<a href='" + url + "' class='sg-slide-link'>" +
                        "<div class='swiper-zoom-container'>" +
                        "<img src='" + url + "' alt='" + alt + "' " + loadAttrs + ">" +
                        "</div>" +
                        "</a>" +
                        "</div>"
                    );
                }).join("");

                const sgThumbsHTML = sgSlides.map(function (s) {
                    return "<div class='swiper-slide'><img src='" + sgEscAttr(s.thumbSrc) + "' alt='" + sgEscAttr(s.alt) + "' loading='lazy'></div>";
                }).join("");

                const $sgGallery = $(
                    "<div class='sg-swiper-wrap'>" +
                    "<div class='swiper sg-swiper'><div class='swiper-wrapper'>" + sgMainHTML + "</div></div>" +
                    "<button class='sg-navi__btn sg-navi__btn--prev' aria-label='Předchozí' type='button'></button>" +
                    "<button class='sg-navi__btn sg-navi__btn--next' aria-label='Další' type='button'></button>" +
                    "</div>" +
                    "<div class='sg-thumbs swiper'><div class='swiper-wrapper'>" + sgThumbsHTML + "</div></div>"
                );

                $sgGallery.insertBefore($sgImage);
                $sgImage.find(".flags").appendTo($sgGallery.filter(".sg-swiper-wrap"));
                $sgWrapper.addClass("sg-active");

                const sgThumbsSwiper = new Swiper(".sg-thumbs", {
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    watchSlidesProgress: true,
                });

                const sgMainSwiper = new Swiper(".sg-swiper", {
                    loop: true,
                    zoom: { maxRatio: 3, toggle: true },
                    navigation: {
                        nextEl: ".sg-navi__btn--next",
                        prevEl: ".sg-navi__btn--prev",
                    },
                    thumbs: { swiper: sgThumbsSwiper },
                });

                $sgWrapper.on("click", ".sg-slide-link", function (e) {
                    e.preventDefault();
                    const href = $(this).attr("href");
                    const $cbox = $sgThumbsInner.find(".cbox-gal").filter(function () {
                        return $(this).attr("href") === href;
                    });
                    if ($cbox.length) {
                        $cbox.first().click();
                    } else if (typeof $.colorbox === "function") {
                        $.colorbox({ href: href, photo: true, maxWidth: "95%", maxHeight: "95%" });
                    }
                });

                const sgUrlKey = function (u) {
                    return String(u || "").split("?")[0].split("#")[0];
                };
                const sgSlideKeys = sgSlides.map(function (s) { return sgUrlKey(s.url); });
                const sgSyncToUrl = function (url) {
                    const key = sgUrlKey(url);
                    if (!key) return;
                    const idx = sgSlideKeys.indexOf(key);
                    if (idx >= 0 && idx !== sgMainSwiper.realIndex) {
                        sgMainSwiper.slideToLoop(idx, 300);
                    }
                };

                if (typeof shoptet !== "undefined" && shoptet.products && typeof shoptet.products.replaceImage === "function" && !shoptet.products._sgWrapped) {
                    shoptet.products._sgWrapped = true;
                    const sgOrigReplaceImage = shoptet.products.replaceImage;
                    shoptet.products.replaceImage = function (src) {
                        const result = sgOrigReplaceImage.apply(this, arguments);
                        sgSyncToUrl(typeof src === "string" ? src : $(".p-main-image img").attr("src"));
                        return result;
                    };
                }
            }
        }

        $(".surcharge-list select option[data-index='0']").html(terezaDataLayer.surchargeNoText);
        // Text tlačítka řídíme z datalayeru — Shoptet v EN mutaci překládá "Add to cart",
        // klientka chce britské "Add to basket"
        if (terezaDataLayer.addToCartBtnText) {
            $(".add-to-cart-button").html(terezaDataLayer.addToCartBtnText);
        }
        $(".delivery-time-label").html(terezaDataLayer.shippingText);
        $("<div class='mydelivery'></div>").insertBefore(".p-to-cart-block");
        $(".p-basic-info-block > .block:first-child").appendTo(".mydelivery");
        $(".detail-parameters tr > th:has(.delivery-time-label)").appendTo(".mydelivery");
        $(".mydelivery .default-variant .availability-label").html(terezaDataLayer.chooseVariantText);

        $(".delivery-time > span").each(function () {
            $(this).html($(this).html().replace(/\./g, ". "));
        });
        $(".link-icon.chat").html(terezaDataLayer.detailProductChat.linkText).wrap("<div class='myquestions'></div>");
        $(".myquestions").appendTo("#product-detail-form");
        $("<a href='#faq'>" + terezaDataLayer.faqLinkText + "</a>").appendTo(".myquestions");
        $(".shipping-options").appendTo(".myquestions");
        $(".container--bannersBenefit").appendTo("#product-detail-form");
        $(".content-modal:has(#formProductQuestion) h1").html(terezaDataLayer.detailProductChat.title);
        // Roletky z krátkého popisu -> .more-information (roletka Parametry se přidává níž)
        const $shortDescription = $(".p-short-description");
        const $moreInfoDiv = $("<div>", { class: "more-information" });
        const $roletky = $shortDescription.find(".roletka");
        const cleanRoletkaTitle = function (text) {
            return String(text).replace(/ /g, " ").replace(/\s+/g, " ").trim();
        };
        const addRoletka = function (title, html) {
            const $titleDiv = $("<div>", { class: "single-information__title" }).append($("<span>").text(title));
            const $textDiv = $("<div>", { class: "single-information__text" }).html(html);

            $("<div>", { class: "single-information" }).append($titleDiv).append($textDiv).appendTo($moreInfoDiv);
        };

        // .roletka > .roletka__nadpis + .roletka__text (obsah se přebírá beze změny)
        $roletky.each(function () {
            const $roletka = $(this);
            const title = cleanRoletkaTitle($roletka.find(".roletka__nadpis").first().text());
            let $text = $roletka.find(".roletka__text").first();

            if ($text.length === 0) {
                $text = $roletka.clone();
                $text.find(".roletka__nadpis").remove();
            }

            const html = ($text.html() || "").trim();

            if (title !== "" || html !== "") {
                addRoletka(title, html);
            }
        });
        const $roletkyParents = $roletky.parent().not($shortDescription);

        $roletky.remove();
        // Obalující <div> z editoru po roletkách nenechávat prázdný
        $roletkyParents.filter(function () {
            return $(this).children().length === 0 && cleanRoletkaTitle($(this).text()) === "";
        }).remove();

        $(".p-data-wrapper").append($moreInfoDiv);

        $(".products-additional .product").attr("class", "product");
        $("<h2 class='additional-products-title related-products-title'>" + terezaDataLayer.relatedProducts.title + "</h2>").prependTo("#productsRelated");

        $(".products-block").each(function (index) {
            $(this)
                .addClass("swiper-wrapper")
                .wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
            $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
            $($(this).find(".product")).addClass("swiper-slide");
            const productSwiper = new Swiper(".myproducts-swiper-" + index, {
                loop: false,
                pagination: {
                    el: ".myswiper-navi-" + index + " .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".myswiper-navi-" + index + " .myswiper-next",
                    prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
                },
                breakpoints: {
                    1600: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    992: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: true,
                        },
                    },
                    500: {
                        spaceBetween: 30,
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: false,
                        },
                    },
                    360: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        navigation: {
                            enabled: false,
                        },
                    },
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
            });
        });
        $("<div class='detail-loader'><div class='reviews-loader'></div></div>").appendTo("#tab-content");
        $.get(
            "/",
            function (data) {
                var response = $($.parseHTML(data));
                $(response).find(".reviews").appendTo(".reviews-loader");
                $(response).find(".milano.loaded").appendTo(".detail-loader");
            },
            null,
            "html"
        ).done(function () {
            $(".milano").appendTo("#content");
            const reviewsSwiper = new Swiper(".reviews .swiper", {
                autoHeight: true,
                loop: false,
                pagination: {
                    el: ".whole-wrap:has(.reviews-inner) .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".whole-wrap:has(.reviews-inner) .swiper-button-next",
                    prevEl: ".whole-wrap:has(.reviews-inner) .swiper-button-prev",
                },
                autoplay: {
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    500: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
            });
        });
        //$("<div class='detail-usps' id='detail-usps'><div class='img-holder'><img src='/user/documents/upload/kodovani/detail-usps-image-1.jpg' alt='' loading='lazy'></div><div class='detail-usps__text'><h2>Proč si vybrat šperky z&nbsp;dílny Terezy&nbsp;Chá</h2><div class='detail-usps__parts'><div class='detail-usp'>Krásné dárkové balení součástí <br>každého šperku</div><div class='detail-usp'>Doprava zdarma <br>při nákupu nad 3&nbsp;000&nbsp;Kč</div><div class='detail-usp'>Každý šperk vytvářím <br>s tou největší pečlivostí</div><div class='detail-usp'>Jedinečný design</div></div></div></div>").appendTo("#tab-content")
        for (item of terezaDataLayer.variantsTooltip) {
            if ($("#parameter-id-" + item.id).length > 0) {
                $("<span class='mytooltip' data='" + item.id + "'>i</span>").appendTo(".variant-list:has(#parameter-id-" + item.id + ") > th");
            }
            $(".variant-list > th .mytooltip").click(function () {
                if ($(".mytooltip-window[data='tooltip-" + $(this).attr("data") + "']").length == 0) {
                    $(
                        "<div class='mytooltip-window' data='tooltip-" +
                        $(this).attr("data") +
                        "' style='display: none;'><div class='clickable-part'></div><div class='mytooltip-inner'><div class='close-tooltip'></div><div class='mytooltip-inner__title'>" +
                        $("#parameter-id-" + $(this).attr("data")).attr("data-parameter-name") +
                        "</div>" +
                        terezaDataLayer.variantsTooltip.find((item) => item.id === $(this).attr("data")).text +
                        "</div></div>"
                    ).appendTo(".overall-wrapper");
                    $(".mytooltip-window[data='tooltip-" + $(this).attr("data") + "']").fadeIn(300);
                } else {
                    $(".mytooltip-window[data='tooltip-" + $(this).attr("data") + "']").fadeIn(300);
                }
            });
        }
        $(document).on("click", ".close-tooltip", function () {
            $(this).closest(".mytooltip-window").fadeOut(300);
        });

        $(document).on("click", ".clickable-part", function () {
            $(".mytooltip-window").fadeOut(300);
        });

        // Shoptet u produktu bez vyplněného popisu vypisuje systémovou hlášku — schováme ji
        let $firstDescriptionParagraph = $(".basic-description > p:first-child");
        if ($firstDescriptionParagraph.length && $firstDescriptionParagraph.text().indexOf(terezaDataLayer.noDescriptionText) > -1) {
            $firstDescriptionParagraph.hide();
        }
        $($(".detail-parameters.second tr")).each(function () {
            if ($(this).find(".row-header-label").text().indexOf("FAQ") > -1) {
                $(this).hide();
                var array = $(this).find("td").text().split(","); //rozdělím si číslovky do pole
                $.each(array, function (index, value) {
                    if ($(".faq").length == 0) {
                        $(
                            "<div class='faq' id='faq'><h2>" +
                            terezaDataLayer.faqTitle +
                            "</h2><div class='faq-inner'></div><div class='faq-additional'><div class='faq-additional__title'>" +
                            terezaDataLayer.faqAdditionalText.title +
                            "</div><a href='" +
                            terezaDataLayer.faqAdditionalText.link.link +
                            "' class='faq-additional__link'>" +
                            terezaDataLayer.faqAdditionalText.link.text +
                            "</a></div></div>"
                        ).appendTo(".basic-description");
                    }
                    var targetFaq = terezaDataLayer.faqs.find(function (faq) {
                        return faq.id == value;
                    });

                    if (targetFaq) {
                        $("<div class='question' data-num='" + targetFaq.id + "'><div class='question-title'>" + targetFaq.title + "</div><div class='question-answer'>" + targetFaq.text + "</div></div>").appendTo(".faq-inner");
                    }
                });
            }
            // V DETAILS chceme jen popisné parametry. Jediný rozlišovací znak, který
            // markup nabízí, je odsazení: kategorii a parametry pro filtrování Shoptet
            // vypisuje jako "<td> hodnota </td>", popisné parametry jako "<td>hodnota</td>".
            // Dřív se schovával natvrdo řádek s textem "Kategorie" a zbytek mizel jen
            // náhodou přes deduplikaci stejných názvů — v EN mutaci se názvy neshodují,
            // takže tam prosákly všechny filtrovací parametry.
            let cellHtml = $(this).find("td").html() || "";
            if (cellHtml !== cellHtml.trim()) {
                $(this).hide();
            }
        });

        if ($(".more-information").length == 0) {
            $("<div class='more-information'><div class='single-information parameters'><div class='single-information__title'>" + terezaDataLayer.parametersToggleTitle + "</div><div class='single-information__text'></div></div></div>").appendTo(".p-data-wrapper");
        } else {
            $("<div class='single-information parameters'><div class='single-information__title'><span>" + terezaDataLayer.parametersToggleTitle + "</span></div><div class='single-information__text'></div></div>").appendTo(".more-information");
        }
        $(".detail-parameters.second").appendTo(".single-information.parameters .single-information__text");
        $(".single-information__title").on("click", function () {
            var $infoText = $(this).next(".single-information__text");
            var $singleInfoDiv = $(this);

            if ($singleInfoDiv.hasClass("open")) {
                $infoText.slideUp(function () {
                    $singleInfoDiv.removeClass("open");
                });
            } else {
                $infoText.slideDown();
                $singleInfoDiv.addClass("open");
            }
        });

        $("<div class='send-tip'><span>" + terezaDataLayer.tipButtonText + "</span></div>").appendTo(".add-to-cart");
        $(document).on("click", ".send-tip", function () {
            if ($(".mytooltip-window[data='gift-tip']").length == 0) {
                $(
                    '<div class="mytooltip-window" data="gift-tip"><div class="clickable-part"></div><div class="mytooltip-inner"><div class="close-tooltip"></div><div class="gift-photo"><img src="' +
                    $(".p-main-image img").attr("src") +
                    '"><div class="mychosen-variants"></div></div><div class="gift-form">[w-form-BYNCQ]</div></div></div>'
                ).appendTo("body");
                wtFormsInstance.reinit();
            } else {
                $(".gift-photo img").attr("src", $(".p-main-image img").attr("src"));
                $(".hidden-image-src").val($(".p-main-image img").attr("src"));
                $(".mytooltip-window[data='gift-tip']").fadeIn();
                $(".gift-chosen-paramameter").remove(); /*
                if ($(".variant-list").length > 0) {
                    $(".variant-list").each(function () {
                        if ($(this).find(".advanced-parameter-inner.yes-before").length > 0) {
                            $("<span class='gift-chosen-paramameter'><span class='gift-chosen-parameter__name'>" + $(this).find('td > div').attr('data-parameter-name') + ": </span><span class='gift-chosen-parameter__value'>" + $(this).find('.yes-before').attr('data-original-title') + "</span><br></span>").appendTo(".gift-parameters");
                        } else if ($(this).find(".my-variant.active").length > 0) {
                            $("<span class='gift-chosen-paramameter'><span class='gift-chosen-parameter__name'>" + $(this).find('select').attr('data-parameter-name') + ": </span><span class='gift-chosen-parameter__value'>" + $(this).find('.my-variant.active').text() + "</span><br></span>").appendTo(".gift-parameters");
                        }
                    })
                }*/
                let variants = terezaDataLayer.chosenVariantTitle;
                let variantsModal = "<span class='mychosen-variants__title'>" + terezaDataLayer.chosenVariantTitle + "</span>";
                if ($(".variant-list").length > 0) {
                    $(".variant-list").each(function () {
                        if ($(this).find(".advanced-parameter-inner.yes-before").length > 0) {
                            let variantText = $(this).find("div[data-parameter-name]").attr("data-parameter-name") + ": " + $(this).find(".yes-before").attr("data-original-title");
                            variants = variants + "\r\n" + variantText;
                            variantsModal = variantsModal + "<span>" + variantText + "</span>";
                        } else if ($(this).find(".my-variant.active").length > 0) {
                            let variantText = $(this).find("select[data-parameter-name]").attr("data-parameter-name") + ": " + $(this).find(".my-variant.active").text().trim();
                            variants = variants + "\r\n" + variantText;
                            variantsModal = variantsModal + "<span>" + variantText + "</span>";
                        }
                    });
                }
                $(".hidden-variants").val(variants);
                $(".mychosen-variants").html(variantsModal);
            }
        });

        $(document).on("input", 'input[data-name="gifted-name"]', function () {
            var currentValue = $(this).val();
            $("span.gifted-name").text(currentValue);
        });

        document.addEventListener("wtFormLoaded", function () {
            if ($(window).width() < 768) {
                $(".gift-photo").insertAfter(".gift-title .special");
            }
            $(".gift-chosen-paramameter").remove();
            $(".gift-link").attr("href", window.location.href);
            let variants = terezaDataLayer.chosenVariantTitle;
            let variantsModal = "<span class='mychosen-variants__title'>" + terezaDataLayer.chosenVariantTitle + "</span>";
            if ($(".variant-list").length > 0) {
                $(".variant-list").each(function () {
                    if ($(this).find(".advanced-parameter-inner.yes-before").length > 0) {
                        let variantText = $(this).find("div[data-parameter-name]").attr("data-parameter-name") + ": " + $(this).find(".yes-before").attr("data-original-title");
                        variants = variants + "\r\n" + variantText;
                        variantsModal = variantsModal + "<span>" + variantText + "</span>";
                    } else if ($(this).find(".my-variant.active").length > 0) {
                        let variantText = $(this).find("select[data-parameter-name]").attr("data-parameter-name") + ": " + $(this).find(".my-variant.active").text().trim();
                        variants = variants + "\r\n" + variantText;
                        variantsModal = variantsModal + "<span>" + variantText + "</span>";
                    }
                });
            }
            $(".hidden-product-link").val($(location).attr("href"));
            $(".hidden-variants").val(variants);
            $(".mychosen-variants").html(variantsModal);
            $(".hidden-image-src").val($(".p-main-image img").attr("src"));
            $('.gift-form button[type="submit"]').on("mousedown touchstart", function () {
                /*let tipContent = $('.tip-final-message').html().replace(/<br\s*\/?>/g, '\n');
                                                                                tipContent += '\n\n';

                                                                                const imgSrc = $('.gift-photo img').attr('src');
                                                                                if (imgSrc) {
                                                                                    $(".hidden-image-src").val(imgSrc);
                                                                                }

                                                                                console.log(tipContent);
                                                                                $('.myfinal-message').val(tipContent);*/
            });
        });
    }
    if ($(".id-966").length > 0) {
        //KONTAKT
        $(".form-group:has(#phone)").insertBefore(".form-group:has(textarea)");
        $(".myform input#fullName").attr("placeholder", terezaDataLayer.contactPage.placeholders.name);
        $(".myform input#email").attr("placeholder", terezaDataLayer.contactPage.placeholders.mail);
        $(".myform input#phone").attr("placeholder", terezaDataLayer.contactPage.placeholders.phone);
        $(".myform textarea[name='message']").attr("placeholder", terezaDataLayer.contactPage.placeholders.message);
        $("#formContact").submit(function (event) {
            // Zabránění výchozímu odeslání formuláře
            event.preventDefault();

            // Získání textarea v rámci formuláře
            var textarea = $(this).find("textarea");

            // Získání hodnoty textarea
            var textvalue = textarea.val();

            // Získání hodnoty telefonního čísla
            var phoneNumber = $("#phone").val();

            // Přidání telefonního čísla k existujícímu textu v textarea
            textvalue = textvalue + "; " + terezaDataLayer.contactPage.placeholders.phone + ": " + phoneNumber;

            // Nastavení nové hodnoty textarea
            textarea.val(textvalue);

            // Odeslání formuláře
            $(this).unbind("submit").submit();
        });
    }
    $(".whole-wrap:has(.product) .swiper-button-next, .whole-wrap:has(.product) .swiper-button-prev").css("top", $(".whole-wrap .product .image").innerHeight() / 2 + "px");
    $(".navigation-buttons a[data-target=cart]").removeClass("toggle-window");
    // Zrušení otevření dialogu pro login button
    // Button má data-dialog-id="login" a aria-controls="login", které způsobují otevření dialogu
    $(".navigation-buttons button.top-nav-button-login")
        .removeAttr("aria-haspopup")
        .removeAttr("data-dialog-id")
        .removeAttr("aria-controls")
        .removeAttr("data-target")
        .removeClass("toggle-window")
        .on("click", function (e) {
            // stopImmediatePropagation() zastaví všechny další handlery včetně případných Shoptet listenerů
            e.stopImmediatePropagation();
            e.preventDefault();
            window.location.href = "/login";
        });
    if ($(".content-window.search-window").length > 0) {
        $(".content-window-in.search-window-in input[type='search']").attr("placeholder", $(".content-window-in.search-window-in .search > h2").text());
        var position = $("#header").offset().top;
        var height = $("#header").outerHeight(); // Získá výšku včetně paddingu
        var total = position + height;
        $(".content-window.search-window").css("top", total + "px");
    }
    if ($(".id--9").length > 0) {
        if ($(".cart-table tr[data-micro-sku='2372']").length == 0) {
            $(
                "<div class='myupsell'><div class='myupsell-image'><img src='" +
                terezaDataLayer.cartUpsell.image +
                "' alt='" +
                terezaDataLayer.cartUpsell.title +
                "'></div><div class='myupsell-text'><div class='myupsell-text__title'>" +
                terezaDataLayer.cartUpsell.title +
                "</div><div class='myupsell-text_subtitle'>" +
                terezaDataLayer.cartUpsell.subtitle +
                "</div></div><div class='myupsell-sellpart'><div class='myupsell-info_price'>" +
                terezaDataLayer.cartUpsell.price +
                "</div><div class='myupsell-add-to-cart' price-id='" +
                terezaDataLayer.cartUpsell.priceId +
                "'>" +
                terezaDataLayer.cartUpsell.btnText +
                "</div></div></div>"
            ).insertAfter(".cart-table");
        }
        $(document).on("click", ".myupsell-add-to-cart", function () {
            var priceId = $(this).attr("price-id");
            if (priceId) {
                shoptet.cartShared.addToCart({ priceId: parseInt(priceId) }, true);
            }
        });
        $(".cart-table tr:not(.related)").each(function () {
            $(this).find(".cart-p-image img").attr("data-src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "orig"));
        });
        if ($(".discount-coupon__title").length == 0) {
            $("<h4 class='discount-coupon__title'>" + terezaDataLayer.cart.discountCouponTitle + "</h4>").prependTo(".discount-coupon");
        }
        $(".discount-coupon .form-control").attr("placeholder", terezaDataLayer.cart.discountCouponInputPlaceholder);
        $(".discount-coupon button[type='submit']").html(terezaDataLayer.cart.discountCouponButtonText);
        if ($(".mydetails").length == 0) {
            $(".delivery-time").wrap("<div class='mydetails'></div>");
        }
        if ($(".delivery-time strong").length > 0) {
            $(".delivery-time strong").html($(".delivery-time strong").html().replace(/\./g, ". "));
        }
        $(".row.summary > div:has(.extra)").prependTo(".mydetails");
        if ($(window).width() < 1200) {
            $(".cart-table tr:not(.related)").each(function () {
                $(this).find(".availability-label").appendTo($(this).find(".p-name"));
            });
        }

        function saveToLocalStorage() {
            var newItems = {};

            // Projedeme všechny řádky tabulky s třídou 'removeable'
            $("tr.removeable").each(function () {
                var identifier = $(this).attr("data-micro-identifier");
                var imgSrc = $(this).find("td.cart-p-image img").attr("data-src");

                if (identifier && imgSrc) {
                    newItems[imgSrc] = identifier;
                }
            });
            $(".free-gift").each(function () {
                var identifier = $(this).find(".free-gift-name").text();
                var imgSrc = $(this).find(".free-gifts-img-hover img").attr("src");
                if (identifier && imgSrc) {
                    newItems[imgSrc] = identifier;
                }
            });

            // Uložit nové položky do Local Storage
            localStorage.setItem("cartItems", JSON.stringify(newItems));

            // Odstranění neexistujících položek z Local Storage
            var savedItems = JSON.parse(localStorage.getItem("cartItems")) || {};
            $.each(savedItems, function (key, value) {
                if (!newItems[key]) {
                    delete savedItems[key];
                }
            });

            // Uložit aktualizované položky zpět do Local Storage
            localStorage.setItem("cartItems", JSON.stringify(savedItems));
        }

        // Zavolání funkce při načtení stránky
        saveToLocalStorage();
        if ($(".cart-empty").length > 0) {
            if ($(".buyme").length == 0) {
                $("<div class='buyme'></div>").appendTo(".cart-inner.cart-empty");
            }
            $("#formSearchFormContent input").attr("placeholder", terezaDataLayer.emptyCart.placeholder);
            $(".empty-cart-boxes > div:first-child h3").html(terezaDataLayer.emptyCart.toTheCategoryText);
            $(".empty-cart-boxes > div:has(.search) h3").html(terezaDataLayer.emptyCart.searchText);
            $(".cart-content:has(.contact-box)").attr("class", "myempty").prependTo(".cart-empty > .cart-row");
            $(".empty-cart-boxes > div").attr("class", "myempty").prependTo(".cart-empty > .cart-row");
            $.get(
                "/",
                function (data) {
                    var response = $($.parseHTML(data));
                    $(".buyme").html(response.find("#products-" + terezaDataLayer.emptyCart.hpSliderId));
                },
                null,
                "html"
            ).done(function () {
                $("<h2 class='buyme-title'>" + terezaDataLayer.emptyCart.sliderTitle + "</h2>").prependTo(".buyme");
                $(".products-block").addClass("swiper-wrapper").wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper'></div></div>");
                $("<div class='myswiper-navi'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo(".whole-wrap");
                $(".product").addClass("swiper-slide");
                $(".product").each(function () {
                    if ($(this).find('.flag[class*="flag-material"]').length > 0 || $(this).find(".widget-parameter-wrapper").length > 0) {
                        if ($(this).find(".material").length == 0) {
                            $("<div class='material'></div>").appendTo($(this).find(".p-in-in"));
                            $(this).find('.flag[class*="flag-material"]').appendTo($(this).find(".material"));
                            $(this).find(".widget-parameter-list").appendTo($(this).find(".material"));
                        }
                    }
                    $(this).find(".image img").attr("src", $(this).find(".image img").attr("data-src"));
                });
                const productSwiper = new Swiper(".myproducts-swiper", {
                    loop: false,
                    pagination: {
                        el: ".myswiper-navi .swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".myswiper-navi .myswiper-next",
                        prevEl: ".myswiper-navi .myswiper-prev",
                    },
                    breakpoints: {
                        1600: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                            spaceBetween: 30,
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                        },
                        992: {
                            spaceBetween: 40,
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                        },
                        768: {
                            spaceBetween: 20,
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                            navigation: {
                                enabled: true,
                            },
                        },
                        500: {
                            spaceBetween: 30,
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                            navigation: {
                                enabled: false,
                            },
                        },
                        360: {
                            spaceBetween: 20,
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            navigation: {
                                enabled: false,
                            },
                        },
                        320: {
                            spaceBetween: 10,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                        },
                    },
                });
                $(".whole-wrap:has(.product) .swiper-button-next, .whole-wrap:has(.product) .swiper-button-prev").css("top", $(".whole-wrap .product .image").innerHeight() / 2 + "px");
            });
        }
    }
    if ($(".id--16").length > 0) {
        $("<span class='payment-logo'></span>").insertAfter(".radio-wrapper:not(:has(.payment-logo)) .payment-info");
        $(".payment-logo").each(function () {
            if ($(this).css("mask-image") == "none") {
                $(this).addClass("hide-this");
            }
        });
        var cartItems = JSON.parse(localStorage.getItem("cartItems")) || {};
        $(".order-summary-item").each(function () {
            // Získat hodnotu z atributu data-micro-identifier
            if ($(this).hasClass("cart-item-gift")) {
                var identifier = $(this).find(".cart-item-name > span").text();
            } else {
                var identifier = $(this).attr("data-micro-identifier");
            }

            // Najít odpovídající hodnotu v Local Storage
            var obrazek = null;
            $.each(cartItems, function (imgSrc, storedIdentifier) {
                if (storedIdentifier === identifier) {
                    obrazek = imgSrc;
                    return false; // Zastavit smyčku, když se najde odpovídající hodnota
                }
            });

            // Podmínka, zda se obrázek našel nebo ne
            if (obrazek) {
                $("<div class='img-holder'><img src='" + obrazek + "'></div>").prependTo($(this));
            }
        });
        $(".cart-inner .next-step .next-step-back").html(terezaDataLayer.cart.backToShopText);
        $(".order-summary-item").each(function () {
            if ($(this).find("strong").text().indexOf(terezaDataLayer.cart.discountLabel) > -1) {
                $(this).addClass("discount");
            }
        });
    }
    if ($(".id--17").length > 0) {
        var cartItems = JSON.parse(localStorage.getItem("cartItems")) || {};
        $(".order-summary-item").each(function () {
            // Získat hodnotu z atributu data-micro-identifier
            if ($(this).hasClass("cart-item-gift")) {
                var identifier = $(this).find(".cart-item-name > span").text();
            } else {
                var identifier = $(this).attr("data-micro-identifier");
            }

            // Najít odpovídající hodnotu v Local Storage
            var obrazek = null;
            $.each(cartItems, function (imgSrc, storedIdentifier) {
                if (storedIdentifier === identifier) {
                    obrazek = imgSrc;
                    return false; // Zastavit smyčku, když se najde odpovídající hodnota
                }
            });

            // Podmínka, zda se obrázek našel nebo ne
            if (obrazek) {
                $("<div class='img-holder'><img src='" + obrazek + "'></div>").prependTo($(this));
            }
        });
        $(".cart-inner .next-step .next-step-back").html(terezaDataLayer.cart.backToShopText);
        $(".order-summary-item").each(function () {
            if ($(this).find("strong").text().indexOf(terezaDataLayer.cart.discountLabel) > -1) {
                $(this).addClass("discount");
            }
        });
    }

    if ($(".id--15").length > 0) {
        $("h1.order-summary-heading").html(terezaDataLayer.thankYouPage.mainTitle);
        $("<div class='order-summary-subtitle'><span class='subtitle-title'>" + terezaDataLayer.thankYouPage.orderRecievedText + "</span><span class='subtitle-number'>" + terezaDataLayer.thankYouPage.orderNumberText + " " + $(".reca-number strong").html() + "</span></div>").insertAfter("h1.order-summary-heading");
        $(".cart-p-image img").each(function () {
            $(this).attr("data-src", myImageSize($(this).attr("data-src"), "orig")).wrap("<div class='img-holder'></div>");
        });
        $(".recapitulation-wrapper .order-summary-item.total").html(terezaDataLayer.thankYouPage.orderRecapText);
        $(".recapitulation-wrapper .order-summary-item.summary-thx").html(terezaDataLayer.thankYouPage.orderRecapThxText);
    }
    if ($(".question-title").length > 0) {
        $(".question-title").click(function () {
            $(this).parent().toggleClass("active");
            if ($(this).parent().hasClass("active")) {
                $(this).next(".question-answer").slideDown();
            } else {
                $(this).next(".question-answer").slideUp();
            }
        });
    }
    if ($(".mobile .product .image").length > 0) {
        $(".swap-image").on("touchstart", function () {
            var originalSrc = $(this).attr("data-src");
            var nextSrc = $(this).attr("data-next");

            // Změň src na data-next při doteku
            $(this).attr("src", nextSrc);
        });

        $(".swap-image").on("touchend", function () {
            var originalSrc = $(this).attr("data-src");

            // Změň zpět na původní src (data-src) po opuštění doteku
            $(this).attr("src", originalSrc);
        });
    }
    if ($("time").length > 0) {
        $("time").each(function () {
            $(this).html($(this).html().replace(/\./g, ". "));
        });
    }

    // Vložení šipky do body
    $("body").append('<a href="#" class="back-to-top" style="display: none;"></a>');

    var $backToTop = $(".back-to-top");

    // Sledujeme událost scrollování
    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();

        // Zobrazit šipku při scrollu dolů o 200px, jinak ji skrýt
        if (scrollTop > 200) {
            $backToTop.fadeIn(250);
        } else {
            $backToTop.fadeOut(250);
        }
    });

    // Po kliknutí na šipku posuň stránku zpět na vrch
    $backToTop.click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 600);
    });
    console.time("replaceSpaceWithNbspDuration");

    function replaceSpaceWithNbspInTextNodes(element) {
        const prepositions = ["a", "k", "ke", "s", "z", "ze", "v", "ve", "o", "i", "u", "se", "si", "za", "před", "bez", "na", "do", "po", "od", "pod", "nad", "přes", "mezi", "vedle", "kromě", "okolo", "ať", "co", "který", "které", "která", "protože", "nebo"];
        const prepositionsSet = new Set(prepositions.map((word) => word.toLowerCase()));
        $(element)
            .contents()
            .each(function () {
                if (this.nodeType === 3) {
                    // Textový uzel
                    const words = this.nodeValue.split(/(\s+)/);
                    for (let i = 0; i < words.length - 1; i++) {
                        if (!/\s+/.test(words[i]) && prepositionsSet.has(words[i].toLowerCase())) {
                            words[i] = words[i] + "\u00A0";
                            words.splice(i + 1, 1); // Odstraníme následující mezeru
                        }
                    }
                    this.nodeValue = words.join("");
                } else if (this.nodeType === 1) {
                    // Element (např. HTML značka)
                    replaceSpaceWithNbspInTextNodes(this); // Rekurzivně pro pod-elementy
                }
            });
    }

    replaceSpaceWithNbspInTextNodes("body");

    console.timeEnd("replaceSpaceWithNbspDuration");
    $(".page-introduction").css("opacity", "1");
    $("#content-wrapper").css("opacity", "1");

    if ($(".custom-switcher").length > 0) {
        // Najdeme všechny switchery a jejich obsah
        $(".custom-switcher__choice").click(function () {
            var $clickedChoice = $(this);
            var targetId = $clickedChoice.attr("data");

            // Pokud je už aktivní, nic neděláme
            if ($clickedChoice.hasClass("active")) {
                return;
            }

            // Najdeme aktuálně aktivní obsah a switcher
            var $activeContent = $(".custom-part.active");
            var $activeChoice = $(".custom-switcher__choice.active");
            var $targetContent = $("#" + targetId);

            // Odebereme active třídu z aktuálně aktivních elementů
            $activeChoice.removeClass("active");
            $activeContent.removeClass("active");

            // Přidáme active třídu na switcher
            $clickedChoice.addClass("active");

            // Respektujeme CSS transition
            $activeContent.removeClass("active");
            $targetContent.addClass("active");
        });
    }

    // Marquee info proužek — klonuje <span> v .movable a rolluje v loopu
    const SITE_MSG_SPEED = 27; // px/s

    const buildSiteMsgMarquee = function () {
        const $siteMsgText = $(".site-msg.information").first().find(".text");
        const $siteMsgMovable = $siteMsgText.find(".movable");
        if (!$siteMsgMovable.length) return;

        // jQuery .css() neumí CSS custom properties — nutno přes nativní style API
        const movableEl = $siteMsgMovable[0];

        $siteMsgMovable.find("span.site-msg-clone").remove();
        $siteMsgText.removeClass("js-marquee");
        movableEl.style.removeProperty("--marquee-duration");

        const $originals = $siteMsgMovable.children("span").not(".site-msg-clone");
        if (!$originals.length) return;

        $siteMsgText.addClass("js-marquee");

        const containerWidth = $siteMsgText.outerWidth();

        let setWidth = 0;
        $originals.each(function () {
            setWidth += $(this).outerWidth(true);
        });
        if (setWidth <= 0) return;

        while (setWidth < containerWidth) {
            $originals.each(function () {
                $(this).clone().addClass("site-msg-clone").appendTo($siteMsgMovable);
            });
            setWidth *= 2;
        }

        $siteMsgMovable.children("span").clone().addClass("site-msg-clone").appendTo($siteMsgMovable);

        movableEl.style.setProperty("--marquee-duration", (setWidth / SITE_MSG_SPEED) + "s");
    };

    setTimeout(buildSiteMsgMarquee, 0);

    let siteMsgResizeTimer;
    $(window).on("resize", function () {
        clearTimeout(siteMsgResizeTimer);
        siteMsgResizeTimer = setTimeout(buildSiteMsgMarquee, 150);
    });
});

document.addEventListener("ShoptetCartAddCartItem", function () {
    sessionStorage.removeItem("ProductAddedImage");
    sessionStorage.setItem("ProductAddedImage", $(".p-thumbnails-inner > div > a:first-child > img").attr("data-src"));

    sessionStorage.removeItem("ProductAddedPrice");
    sessionStorage.setItem("ProductAddedPrice", $(".p-detail-inner .p-final-price-wrapper").html());
});

document.addEventListener("shoptet.watchdog.initWatchdog", function () {
    let terezaDataLayer = getTerezaDataLayer();
    $(".content-modal:has(#formProductQuestion) h1").html(terezaDataLayer.detailProductChat.title);
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    let terezaDataLayer = getTerezaDataLayer();
    $(".product").each(function () {
        if ($(this).find('.flag[class*="flag-material"]').length > 0 || $(this).find(".widget-parameter-wrapper").length > 0) {
            if ($(this).find(".material").length == 0) {
                $("<div class='material'></div>").appendTo($(this).find(".p-in-in"));
                if ($(this).find(".flag-material-14kt-zlato").length) {
                    $(this).find(".flag-material-14kt-zlato").clone().appendTo($(this).find(".material"));
                } else {
                    $(this).find('.flag[class*="flag-material"]').appendTo($(this).find(".material"));
                }
                $(this).find(".widget-parameter-list").appendTo($(this).find(".material"));
            }
        }
    });
    if ($(".type-category").length) {
        if ($(".listSorting__controls button[data-sort='-date']").length == 0) {
            const $firstButton = $(".listSorting__controls button").first();
            const dataUrl = $firstButton.attr("data-url").replace(/(\?order=).*/, "$1-date");

            const newButton = $("<button>", {
                type: "button",
                id: "listSortingControl--date",
                class: "listSorting__control",
                "data-sort": "-date",
                "data-url": dataUrl,
                text: terezaDataLayer.sorting.newestText,
            });

            $("<li>").append(newButton).appendTo(".listSorting__controls");
        }

        if (window.location.search.indexOf("order=-date") !== -1) {
            $(".listSorting__controls .listSorting__control")
                .removeClass("listSorting__control--current")
                .removeAttr("aria-disabled")
                .removeAttr("aria-label");
            $('.listSorting__controls button[data-sort="-date"]')
                .addClass("listSorting__control--current")
                .attr("aria-disabled", "true")
                .attr("aria-label", terezaDataLayer.sorting.newestText + terezaDataLayer.sorting.currentSuffix);
        }

        renameRecommendedSorting(terezaDataLayer.sorting);
    }
    if ($(".type-posts-listing").length > 0) {
        if ($(".content-inner").children().first().attr("id") !== "newsWrapper") {
            // Získej všechny elementy před #newsWrapper
            var elementsBeforeNewsWrapper = $("#newsWrapper").prevAll().toArray().reverse();

            // Vytvoř nový div.category-top a div.category-perex a přidej ho na začátek .content-inner
            var categoryTop = $('<div class="category-top"><div class="category-perex"></div></div>');
            $(".content-inner").prepend(categoryTop);

            // Přidej všechny elementy před #newsWrapper do divu.category-perex, vyjma h1
            elementsBeforeNewsWrapper.forEach(function (element) {
                if ($(element).prop("tagName").toLowerCase() !== "h1") {
                    $(".category-perex").append(element);
                }
            });
        }
        let bodyClass = document.querySelector("body").className.split(" ");
        let idClass = bodyClass.find((cls) => cls.startsWith("id-"));

        let idBlog = idClass ? idClass.substring(3) : null; //vytáhnul jsem si id stránky

        if (terezaDataLayer.blogCategories.hasOwnProperty(idBlog)) {
            if ($(".myblog-categories").length == 0) {
                $("<div class='myblog-categories'></div>").insertBefore("#newsWrapper");
                for (item of terezaDataLayer.blogCategories[idBlog]) {
                    $("<a href='" + item.link + "' class='myblog-category'>" + item.text + "</a>").appendTo(".myblog-categories");
                }
            }
        }
    }
    if ($(".id--9").length > 0) {
        $(".cart-table tr:not(.related)").each(function () {
            $(this).find(".cart-p-image img").attr("src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "orig"));
        });
        if ($(".cart-table tr[data-micro-sku='2372']").length == 0) {
            $(
                "<div class='myupsell'><div class='myupsell-image'><img src='" +
                terezaDataLayer.cartUpsell.image +
                "' alt='" +
                terezaDataLayer.cartUpsell.title +
                "'></div><div class='myupsell-text'><div class='myupsell-text__title'>" +
                terezaDataLayer.cartUpsell.title +
                "</div><div class='myupsell-text_subtitle'>" +
                terezaDataLayer.cartUpsell.subtitle +
                "</div></div><div class='myupsell-sellpart'><div class='myupsell-info_price'>" +
                terezaDataLayer.cartUpsell.price +
                "</div><div class='myupsell-add-to-cart' price-id='" +
                terezaDataLayer.cartUpsell.priceId +
                "'>" +
                terezaDataLayer.cartUpsell.btnText +
                "</div></div></div>"
            ).insertAfter(".cart-table");
        }

        if ($(".discount-coupon__title").length == 0) {
            $("<h4 class='discount-coupon__title'>" + terezaDataLayer.cart.discountCouponTitle + "</h4>").prependTo(".discount-coupon");
        }
        $(".discount-coupon .form-control").attr("placeholder", terezaDataLayer.cart.discountCouponInputPlaceholder);
        $(".discount-coupon button[type='submit']").html(terezaDataLayer.cart.discountCouponButtonText);
        if ($(".mydetails").length == 0) {
            $(".delivery-time").wrap("<div class='mydetails'></div>");
        }
        if ($(".delivery-time strong").length > 0) {
            $(".delivery-time strong").html($(".delivery-time strong").html().replace(/\./g, ". "));
        }
        $(".row.summary > div:has(.extra)").prependTo(".mydetails");
        if ($(window).width() < 1200) {
            $(".cart-table tr:not(.related)").each(function () {
                $(this).find(".availability-label").appendTo($(this).find(".p-name"));
            });
        }

        function saveToLocalStorage() {
            var newItems = {};

            // Projedeme všechny řádky tabulky s třídou 'removeable'
            $("tr.removeable").each(function () {
                var identifier = $(this).attr("data-micro-identifier");
                var imgSrc = $(this).find("td.cart-p-image img").attr("data-src");

                if (identifier && imgSrc) {
                    newItems[imgSrc] = identifier;
                }
            });
            $(".free-gift").each(function () {
                var identifier = $(this).find(".free-gift-name").text();
                var imgSrc = $(this).find(".free-gifts-img-hover img").attr("src");
                if (identifier && imgSrc) {
                    newItems[imgSrc] = identifier;
                }
            });

            // Uložit nové položky do Local Storage
            localStorage.setItem("cartItems", JSON.stringify(newItems));

            // Odstranění neexistujících položek z Local Storage
            var savedItems = JSON.parse(localStorage.getItem("cartItems")) || {};
            $.each(savedItems, function (key, value) {
                if (!newItems[key]) {
                    delete savedItems[key];
                }
            });

            // Uložit aktualizované položky zpět do Local Storage
            localStorage.setItem("cartItems", JSON.stringify(savedItems));
        }

        // Zavolání funkce při načtení stránky
        saveToLocalStorage();
    }
    if ($(".mobile .product .image").length > 0) {
        $(".swap-image").on("touchstart", function () {
            var originalSrc = $(this).attr("data-src");
            var nextSrc = $(this).attr("data-next");

            // Změň src na data-next při doteku
            $(this).attr("src", nextSrc);
        });

        $(".swap-image").on("touchend", function () {
            var originalSrc = $(this).attr("data-src");

            // Změň zpět na původní src (data-src) po opuštění doteku
            $(this).attr("src", originalSrc);
        });
    }
    if ($(".cart-empty").length > 0) {
        if ($(".buyme").length == 0) {
            $("<div class='buyme'></div>").appendTo(".cart-inner.cart-empty");
        }
        $("#formSearchFormContent input").attr("placeholder", terezaDataLayer.emptyCart.placeholder);
        $(".empty-cart-boxes > div:first-child h3").html(terezaDataLayer.emptyCart.toTheCategoryText);
        $(".empty-cart-boxes > div:has(.search) h3").html(terezaDataLayer.emptyCart.searchText);
        $(".cart-content:has(.contact-box)").attr("class", "myempty").prependTo(".cart-empty > .cart-row");
        $(".empty-cart-boxes > div").attr("class", "myempty").prependTo(".cart-empty > .cart-row");
        $.get(
            "/",
            function (data) {
                var response = $($.parseHTML(data));
                $(".buyme").html(response.find("#products-" + terezaDataLayer.emptyCart.hpSliderId));
            },
            null,
            "html"
        ).done(function () {
            $("<h2 class='buyme-title'>" + terezaDataLayer.emptyCart.sliderTitle + "</h2>").prependTo(".buyme");
            $(".products-block").addClass("swiper-wrapper").wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper'></div></div>");
            $("<div class='myswiper-navi'><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div><div class='swiper-pagination'></div></div>").appendTo(".whole-wrap");
            $(".product").addClass("swiper-slide");
            $(".product").each(function () {
                if ($(this).find('.flag[class*="flag-material"]').length > 0 || $(this).find(".widget-parameter-wrapper").length > 0) {
                    if ($(this).find(".material").length == 0) {
                        $("<div class='material'></div>").appendTo($(this).find(".p-in-in"));
                        $(this).find('.flag[class*="flag-material"]').appendTo($(this).find(".material"));
                        $(this).find(".widget-parameter-list").appendTo($(this).find(".material"));
                    }
                }
                $(this).find(".image img").attr("src", $(this).find(".image img").attr("data-src"));
            });
            const productSwiper = new Swiper(".myproducts-swiper", {
                loop: false,
                pagination: {
                    el: ".myswiper-navi .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".myswiper-navi .myswiper-next",
                    prevEl: ".myswiper-navi .myswiper-prev",
                },
                breakpoints: {
                    1600: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    992: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: true,
                        },
                    },
                    500: {
                        spaceBetween: 30,
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        navigation: {
                            enabled: false,
                        },
                    },
                    360: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        navigation: {
                            enabled: false,
                        },
                    },
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
            });
            $(".whole-wrap:has(.product) .swiper-button-next, .whole-wrap:has(.product) .swiper-button-prev").css("top", $(".whole-wrap .product .image").innerHeight() / 2 + "px");
        });
    }

    if ($(".advanced-order").length > 0) {
        $(".advanced-order > .h1:not(.advanced-order-suggestion)").addClass("advanced-order__main-title").html(terezaDataLayer.advancedOrder.title);
        $(".h2[data-testid='textPopupProductName']").wrap("<div class='product-added'></div>");
        $("<div class='img-holder'><img src='" + sessionStorage.getItem("ProductAddedImage") + "'></div>").prependTo(".product-added");
        $("<div class='p-final-price-wrapper'>" + sessionStorage.getItem("ProductAddedPrice") + "</div>").appendTo(".product-added");
        $(".advancedOrder__buttons > button").addClass("btn-default").html(terezaDataLayer.advancedOrder.backToShoppingBtnText);
        $(".advancedOrder__buttons > a").html(terezaDataLayer.advancedOrder.goToCartBtnText);
        $(".advanced-order .extras-wrap").insertAfter(".advancedOrder__buttons");
        $(".extra.back .btn").click(function () {
            $("#cboxClose").click();
        });
    }

    if ($("time").length > 0) {
        $("time").each(function () {
            $(this).html($(this).html().replace(/\./g, ". "));
        });
    }
});

/*
let czTerezaDataLayer = {

    "cookies": {
        "submitBtnText": "Přijmout vše",
        "ownSettingsButtonText": "Nastavení",
    },
    "emptyCart": {
        "hpSliderId": "1",
        "searchText": "Hledáte něco konkrétního?",
        "toTheCategoryText": "Objevujte nabídku šperků",
        "sliderTitle": "Oblíbené",
        "placeholder": "Co potřebujete najít?",
    },
    "parametersToggleTitle": "Detaily",
    "noDescriptionText": "Popis produktu není dostupný",
    "surchargeNoText": "Ne",
    "chosenVariantTitle": "Zvolená varianta šperku:",
    "sorting": {
        "priorityText": "Doporučuji",
        "newestText": "Nejnovější",
        "currentSuffix": " - Aktuálně nastavené řazení",
    },
    "thankYouPage": {
        "mainTitle": "Děkuji za vaši objednávku.",
        "orderRecievedText": "Objednávka přijata",
        "orderNumberText": "Číslo objednávky: ",
        "orderRecapText": "Rekapitulaci Vám zašlu i e-mailem",
        "orderRecapThxText": "Děkuji",
    },
    "cart": {
        "discountCouponTitle": "Dárkový poukaz",
        "discountCouponButtonText": "Uplatnit",
        "discountCouponInputPlaceholder": "Vložit kód poukazu",
        "backToShopText": "Zpět do obchodu",
        "discountLabel": "Sleva",
    },
    "blogCategories": {
        "682": [
            {
                "text": "Péče",
                "link": "/pece",
            },
            {
                "text": "Tipy na dárky",
                "link": "/tipy-na-darky",
            },
            {
                "text": "Kameny",
                "link": "/kameny",
            },
            {
                "text": "Inspirace",
                "link": "/inspirace",
            },
        ],
    },
    "contactPage": {
        "placeholders": {
            "name": "Vaše jméno",
            "mail": "E-mail",
            "phone": "Telefon",
            "message": "Vzkaz",
        },
    },
    "shippingText": "Doručení možné do",
    "addToCartBtnText": "Přidat do košíku",
    "megaMenu": {
        "id": "744",
        "placeholderPhoto": "https://dummyimage.com/600x800/000/fff",
        "photos": [
            {
                "link": "/nausnice/",
                "photo": "https://dummyimage.com/600x800/9c489c/fff",
            },
            {
                "link": "/ze-stribra/",
                "photo": "https://dummyimage.com/600x800/13cfbc/fff",
            },

        ],
        "unclickableCategories": ["766", "772", "790"],
    },
    "megaMenuAdditionalInfo": "Doprava zdarma v rámci ČR<br>při nákupu nad 3.000 Kč",
    "instagram": {
        "title": "Buďme v kontaktu",
        "subtitle": "IG: @TEREZA_CHA_JEWELLERY",
        "numberOfPosts": "6",
    },
    "relatedProducts": {
        "title": "Vytvořte si perfektní kombinaci",
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ornare sed metus ullamcorper pharetra. Aenean dictum, velit a ultricies pulvinar, mauris arcu auctor tortor.",
    },
    "variantsTooltip": [
        {
            "id": "24",
            "text": "<p>Velikost gumičky jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "21",
            "text": "<p>Barva povrchové úpravy stříbra marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "27",
            "text": "<p>Délka náhrdelníku marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "33",
            "text": "<p>Drahý kámen marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "61",
            "text": "<p>Hodnota poukazu marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "42",
            "text": "<p>Obvod zápěstí napevno marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "54",
            "text": "<p>Velikost prstenu marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "66",
            "text": "<p>Barva zlata marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
        {
            "id": "64",
            "text": "<p>Zapínání marzipan jelly-o tiramisu sugar plum cupcake lollipop cotton candy candy canes. Powder marshmallow bonbon marshmallow cupcake lollipop lemon drops oat cake. Apple pie wafer fruitcake halvah donut candy canes cake. Chocolate cake muffin bonbon toffee macaroon sweet roll fruitcake. Jujubes chocolate bar fruitcake cupcake marzipan tootsie roll biscuit liquorice jelly-o. Bear claw sesame snaps bonbon lemon drops candy canes liquorice gingerbread. Gingerbread caramels sweet roll icing macaroon brownie bear claw tart. Macaroon cheesecake soufflé cotton candy carrot cake danish marzipan shortbread cookie. Macaroon candy pastry cupcake sugar plum donut. Jelly dessert chocolate ice cream macaroon lollipop shortbread. Jelly chupa chups sesame snaps jujubes pastry pie chupa chups lemon drops. Bear claw jelly-o candy icing jujubes marshmallow cookie.</p><p><img src='/user/documents/upload/kodovani/gold.jpg' alt=''> ŽLUTÉ ZLATO 10 KARÁTŮ - Carrot cake tiramisu bonbon soufflé topping</p><p><img src='/user/documents/upload/kodovani/rosegold.jpg' alt=''> RŮŽOVÉ ZLATO 18 KARÁTŮ - Dessert wafer soufflé pie cake halvah oat cake</p><p><img src='/user/documents/upload/kodovani/silver.jpg' alt=''> RHODIUM - Jelly beans apple pie tart croissant marshmallow pudding</p>",
        },
    ],
    "faqTitle": "Otázky a odpovědi",
    "faqs": [
        {
            "id": "1",
            "title": "Jaká je doba výroby?",
            "text": "Jelly lemon drops caramels ice cream donut shortbread. Soufflé cheesecake halvah tiramisu gingerbread dessert dragée sweet. Caramels powder soufflé jelly liquorice candy canes lemon drops caramels. Pastry cookie wafer pastry liquorice pudding tootsie roll. Donut wafer fruitcake soufflé jujubes oat cake muffin soufflé croissant. Lollipop danish wafer apple pie jelly-o. Liquorice powder caramels donut gingerbread. Danish shortbread chupa chups tootsie roll cotton candy cake sugar plum jelly beans cupcake. Chocolate cake marzipan halvah biscuit danish cupcake pastry wafer gummi bears.",
        },
        {
            "id": "2",
            "title": "Možnost vrácení zboží?",
            "text": "Topping jelly beans dessert dessert sesame snaps pie. Jelly beans halvah soufflé cupcake ice cream dessert icing dessert gummi bears. Biscuit cake jujubes chocolate sweet gummi bears dessert sugar plum chupa chups. Jelly-o cake cake candy bear claw marshmallow. Ice cream oat cake chocolate cake tart danish candy canes candy tootsie roll caramels. Chocolate bar cheesecake candy canes jelly-o jelly-o toffee liquorice. Toffee pastry bonbon pudding cupcake. Candy canes wafer marshmallow ice cream topping topping jelly-o bonbon. Tiramisu marzipan gummi bears lollipop toffee sesame snaps marshmallow soufflé. Marzipan gummi bears bonbon gingerbread jelly beans candy canes donut oat cake tootsie roll.",
        },
        {
            "id": "3",
            "title": "Jak o šperk pečovat?",
            "text": "Apple pie jelly-o caramels sweet roll chocolate bear claw carrot cake. Muffin chupa chups carrot cake tiramisu chocolate cake oat cake brownie. Jelly-o lemon drops wafer jujubes dragée wafer pudding. Cake pudding tiramisu shortbread shortbread. Dragée danish carrot cake dragée sweet topping dessert. Dessert carrot cake tart sugar plum jujubes chupa chups sweet bear claw sweet. Gummies cookie chocolate cake croissant ice cream. Wafer marzipan jujubes dessert chupa chups wafer pastry.",
        },
        {
            "id": "4",
            "title": "Mohu se se šperkem koupat v moři?",
            "text": "Caramels donut chocolate bar tart brownie cupcake cake jelly. Bonbon muffin carrot cake cake jelly beans. Ice cream dessert candy canes apple pie chocolate bar. Lemon drops marzipan cupcake sweet roll topping chocolate bar gummi bears lemon drops powder. Icing cake powder candy biscuit pudding oat cake. Shortbread tiramisu cookie soufflé gummi bears.",
        },
        {
            "id": "5",
            "title": "Liquorice jelly danish jelly?",
            "text": "Marzipan candy canes cake fruitcake bonbon tootsie roll chocolate bar. Bear claw chocolate bar wafer chocolate candy jujubes jelly-o chupa chups. Candy canes candy tootsie roll brownie sweet roll pie candy lollipop jelly. Sweet roll chocolate bar candy canes oat cake jujubes jelly beans. Bear claw bonbon gummi bears liquorice jelly toffee lollipop pudding gingerbread. Gingerbread powder gingerbread chocolate cake cotton candy carrot cake oat cake. Oat cake chocolate cake biscuit cotton candy tart gummies gingerbread toffee. Chupa chups toffee dessert macaroon tootsie roll dessert jelly-o shortbread cake. Jujubes cake cake carrot cake gummies tootsie roll tootsie roll dragée cookie. Pudding gingerbread jelly-o biscuit carrot cake liquorice.",
        },
        {
            "id": "6",
            "title": "Shortbread tiramisu cake?",
            "text": "Pudding tootsie roll chocolate pudding muffin biscuit tiramisu icing marzipan. Candy gummies ice cream croissant sesame snaps cake macaroon fruitcake. Liquorice jelly fruitcake gummi bears oat cake halvah shortbread halvah. Donut cake sweet dessert chocolate bar chocolate cake marshmallow. Jelly beans jelly-o chocolate sesame snaps tiramisu. Oat cake cake topping dessert caramels croissant. Brownie chocolate bar halvah cupcake sesame snaps carrot cake. Shortbread pie jelly soufflé dragée.",
        },
        {
            "id": "7",
            "title": "Tart fruitcake gummi bears?",
            "text": "Topping jelly chupa chups cake toffee cheesecake. Ice cream pastry lemon drops sweet macaroon oat cake ice cream cupcake apple pie. Cupcake macaroon cheesecake jelly lollipop marzipan jelly-o. Chocolate soufflé donut candy caramels liquorice. Gummies dragée lollipop tiramisu cotton candy wafer macaroon. Sweet roll oat cake carrot cake brownie cheesecake chocolate cake apple pie cake oat cake.",
        },
        {
            "id": "8",
            "title": "Dessert gummi bears?",
            "text": "Cupcake muffin jelly beans apple pie toffee. Toffee tart jelly-o chocolate cake soufflé chupa chups sweet apple pie. Sweet roll pudding gingerbread chupa chups caramels carrot cake dragée wafer cotton candy. Gummi bears sweet roll liquorice dragée chupa chups tart chocolate cake. Chocolate cake cookie macaroon jelly-o lollipop halvah chocolate apple pie sesame snaps. Bear claw topping candy sesame snaps cotton candy pie. Bonbon gummi bears oat cake cupcake pudding tart shortbread caramels. Chocolate cake sesame snaps halvah muffin icing muffin muffin. Fruitcake halvah tart chocolate bar chocolate bar lollipop pie chocolate bar. Gummies oat cake gingerbread jujubes gummi bears danish.",
        },
    ],
}
*/
